import theme from '@/components/core/theme';
import { css } from '@linaria/core';

export const items = css`
  display: flex;
  align-items: center;
  gap: 1em;
  img {
    width: 1.2em;
  }
`;

export const item = css`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
  align-items: center;
  flex-direction: row;
  @media screen and (width > ${theme.sizes.screens.sm}) {
  }
`;

export const value = css`
  font-weight: 700;
  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 1.25em;
  }
`;

export const separator = css`
  color: #c3cbd9;
  font-size: 1em;
  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 1em;
  }
`;

export const total = css`
  color: #c3cbd9;
  font-weight: 400;
  font-size: 1em;
  @media screen and (width > ${theme.sizes.screens.md}) {
    font-size: 1em;
  }
`;

export const google = css`
  color: ${theme.colors.peoople['gris-medio']};
  font-weight: 500;
`;

export const price = css`
  color: ${theme.colors.peoople['gris-medio-claro']};
`;
